import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';

interface AccountConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmText: string;
  isLoading?: boolean;
  onConfirm: () => void;
}

/** Destructive confirmation in the Account dialog style (Figma 10596:4616). */
export function AccountConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmText,
  isLoading = false,
  onConfirm,
}: AccountConfirmDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="space-y-1">
          <DialogTitle className="text-lg font-medium tracking-normal text-grey-950 dark:text-foreground">
            {title}
          </DialogTitle>
          <DialogDescription className="break-words text-sm font-normal text-grey-500 dark:text-muted-foreground">
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-2 flex-row justify-end gap-2 sm:space-x-0">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            className="h-10 rounded-full px-4 text-sm font-medium text-grey-900 hover:bg-grey-50 disabled:opacity-50 dark:text-foreground dark:hover:bg-muted"
          >
            {t('ACCOUNT_CANCEL', { defaultValue: 'Cancel' })}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="h-10 rounded-full bg-error-700 px-5 text-sm font-medium text-true-white hover:bg-error-700/90 disabled:opacity-50"
          >
            {confirmText}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
